import { ReactElement, useEffect } from 'react';
import { iInstalmentFormValues } from '@services/InstalmentService';
import { tile } from '@interfaces/interfaces';

import { DateInput, TextInput, TileRadioAccessible } from '@components';
import { Field, useFormikContext, getIn } from 'formik';

import styles from './InstalmentStep9.module.scss';

function InstalmentStep9(): ReactElement {
  const { values, touched }: { values: iInstalmentFormValues; touched: any } = useFormikContext();
  const context = useFormikContext();

  const TILE_DATA: tile[] = [
    {
      body: 'Fortnightly',
      value: 'fortnightly',
    },
    {
      body: 'Monthly',
      value: 'monthly',
    },
  ];

  const firstInstalmentDateTitle = (
    <>
      <span>When will your first instalment payment occur?</span>
      <p className={styles.subtitle}>We recommend that your first payment is made within 21 days.</p>
    </>
  );

  useEffect(() => {
    if (values.instalmentFrequency !== '' && parseInt(values.instalmentAmount, 10) > 0) {
      context.setFieldValue('instalmentNumberOfPayments', Math.ceil((parseFloat(values.TotalPaymentArrangementAmount) / (parseFloat(values.instalmentAmount)))).toString());
    }
  }, [values.instalmentFrequency, values.instalmentAmount]);

  useEffect(() => {
    if (getIn(touched, 'firstInstalmentDate')) {
      context.setFieldTouched('firstInstalmentDate');
    }
  }, [values.firstInstalmentDate]);

  return (
    <div>
      <span className="vfH2">What's the maximum amount you can pay?</span>
      <Field name="instalmentFrequency" component={TileRadioAccessible} tileData={TILE_DATA} title="How often would you like to pay each instalment?" orientationRow isMandatory />
      <Field name="instalmentAmount" component={TextInput} title="How much can you pay each instalment?" type="number" orientationRow isMandatory />
      {values.instalmentFrequency !== '' && parseInt(values.instalmentAmount, 10) > 0 && (
        <p>
          You will need to make
          {' '}
          {values.instalmentNumberOfPayments}
          {' '}
          {values.instalmentFrequency}
          {' '}
          payments to complete your payment arrangement.
        </p>
      )}
      <Field
        name="firstInstalmentDate"
        component={DateInput}
        title={firstInstalmentDateTitle}
        isMandatory
        minDate={new Date()}
        maxDate={new Date().setDate(new Date().getDate() + 84)}
        autocomplete="off"
      />
      <br />
      <p>
        <strong>Note: </strong>
        If your application is granted and you don't make each instalment payment by the due date, enforcement of your fines will continue and additional fees may be added.
      </p>
    </div>
  );
}

export default InstalmentStep9;
